import { LegacyRef, useCallback, useRef } from 'react';

const useElementVisibility = (callback: () => void) => {
  const observer = useRef<IntersectionObserver>(null);

  const elementRef = useCallback(
    (node: HTMLDivElement | HTMLSpanElement | LegacyRef<HTMLDivElement>) => {
      // Disconnect if already observer exists
      if (observer.current) observer.current.disconnect();

      //Create new observer for the element, and call setIsAccepted if visible (isIntersecting)
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          callback();
        }
      });
      if (node instanceof Element) observer.current.observe(node);
    },
    [callback]
  );
  return elementRef;
};

export default useElementVisibility;
